/** =========================================================
 * Module: loadingbar.service.js
 * Loading bar control
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.loadingbar')
    .service('loadingbar', loadingbar);

  loadingbar.$inject = ['$timeout', 'cfpLoadingBar'];

  function loadingbar($timeout, cfpLoadingBar) {
    var thBar;
    return {
      show: function () {
        thBar = $timeout(function () {
          cfpLoadingBar.start();
        }, 0);
      },
      hide: function () {
        $timeout.cancel(thBar);
        cfpLoadingBar.complete();
      }
    };
  }
})();
